import { getPrice, getSelectedState, getName } from 'lib/theraStartConstants';

const proFeatures = [
  'Rush filing service',
  '100% accuracy guarantee',
  'Corporate Bylaws template',
  'Worry-Free Compliance offer**',
  '$1000 in Thera Credits',
];

export default function CartSummary({ values }) {
  const {
    package: selectedPackage,
    worryFreeCompliance,
    einDocuments,
    operatingAgreement,
    fasterFiling,
    state,
  } = values;

  const selectedState = getSelectedState(state);

  return (
    <div className="flex flex-col gap-[0.5rem]">
      <div className="mb-[0.5rem] flex items-center justify-between text-[1.125rem] font-semibold">
        <span className="text-neutral-900">{selectedPackage === 'pro' ? 'Pro' : 'Starter'}</span>
        <span className="text-neutral-900">{selectedPackage === 'pro' ? '$250' : '$0'}</span>
      </div>

      {selectedPackage === 'pro' && (
        <>
          <div className="mb-[0.5rem] text-[0.875rem] text-neutral-900/75">Renews at $250/yr.</div>
          <ul className="mb-[0.5rem]">
            {proFeatures.map((f, i) => (
              <li key={i} className="mb-[0.25rem] flex items-center text-[0.875rem] text-neutral-900/80">
                <svg width="1.125rem" height="1.125rem" viewBox="0 0 20 20" fill="none" className="mr-[0.625rem]">
                  <circle cx="10" cy="10" r="10" fill="#EDEDED" />
                  <path
                    d="M6 10.5L9 13.5L14 8.5"
                    stroke="#191919"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {f}
              </li>
            ))}
          </ul>

          <div className="mb-[0.25rem] mt-[0.5rem] flex justify-between text-[1rem] font-semibold text-neutral-900">
            <span className="text-neutral-900">Registered Agent</span> <span className="text-neutral-900">$0</span>
          </div>
          <div className="mb-[0.5rem] text-[0.875rem] text-neutral-500">Renews at $199/yr. Billed after formation.</div>
        </>
      )}

      <div className="mt-[0.5rem] flex items-center justify-between text-[1rem] font-semibold">
        <span className="text-neutral-900">{selectedState?.State} state filing fee</span>
        <span className="text-neutral-900">${selectedState?.TotalStandardStateFee || 0}</span>
      </div>

      {selectedPackage === 'pro' && (
        <div className="mt-[0.25rem] text-[0.75rem] text-neutral-500">This filing fee goes straight to the state.</div>
      )}

      {worryFreeCompliance && (
        <div className="mt-[0.5rem] flex items-center justify-between text-[1rem] font-semibold">
          <span className="text-neutral-900">Worry Free Compliance</span>
          <span className="text-neutral-900">$250</span>
        </div>
      )}

      {einDocuments?.length > 0 &&
        einDocuments.map((doc, idx) => (
          <div key={idx} className="mt-[0.5rem] flex items-center justify-between text-[1rem] font-semibold">
            <span className="text-neutral-900">{getName(doc)}</span>
            <span className="text-neutral-900">${getPrice(doc)}</span>
          </div>
        ))}

      {operatingAgreement && (
        <div className="mt-[0.5rem] flex items-center justify-between text-[1rem] font-semibold">
          <span className="text-neutral-900">Trademark Service</span>
          <span className="text-neutral-900">$499</span>
        </div>
      )}

      {fasterFiling && selectedState && (
        <div className="mt-[0.5rem] flex items-center justify-between text-[1rem] font-semibold">
          <span className="text-neutral-900">{selectedState.State} DBA Services</span>
          <span className="text-neutral-900">${selectedState.TotalDBAFees || 0}</span>
        </div>
      )}
    </div>
  );
}
